import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";
import { IMAGES } from "@/lib/content";

const paras = [
  "You've seen it before. A recruiter sends three CVs. None of the candidates have managed UHNW relationships. None understand the compliance realities of FINMA regulation. None have built a portable book.",
  "You waste twelve weeks interviewing people who were never right for your team — while your competitors hire the talent you need.",
  "The problem is structural: most recruitment firms have never worked a day in banking. How can they identify the talent that builds your AuM?",
];

export const ProblemSolution = () => {
  return (
    <section className="section-py bg-[color:var(--bp-cream)]" data-testid="problem-section">
      <div className="container-bp grid grid-cols-1 items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <SectionHeading
            tone="light"
            eyebrow="The Challenge"
            title="Most recruitment firms have never worked a day in banking."
          />
          <div className="mt-7 space-y-5">
            {paras.map((p, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <p className="max-w-xl text-[15px] leading-[1.8] text-[color:var(--bp-text-body-on-light)]">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-9 flex items-center gap-5 rounded-[var(--radius-md)] border border-[#E2DCCF] bg-[color:var(--bp-cream-2)] p-6">
              <span className="font-display text-5xl font-semibold text-[color:var(--bp-teal)]">85%</span>
              <p className="text-sm leading-snug text-[color:var(--bp-text-body-on-light)]">
                of our placements were <strong className="text-[color:var(--bp-text-on-light)]">passive candidates</strong> — not actively looking. Generalist recruiters can&apos;t reach them.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative aspect-[4/5] overflow-hidden rounded-[var(--radius-lg)] shadow-[0_24px_60px_rgba(10,31,61,0.18)]">
            <img src={IMAGES.meeting} alt="Private banking professionals in discussion" className="h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F3D]/30 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
